
import { Button, Card, Row, Space, Tooltip, Checkbox, Tabs, Modal, Upload } from "antd";
import React, { useState, useRef, useEffect, useMemo } from "react";
import { DownloadOutlined, PlusOutlined, ArrowRightOutlined, UploadOutlined } from "@ant-design/icons"
import { ImCheckboxChecked } from "react-icons/im";
import PageHeader from "../../view/pageheader";
import TableComponent from "../CustomComponents/TableComponent";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { updateHardDiskStatus, getHardDiskList } from "../../store/reducer/wearehouseSlice";
import { useNavigate } from "react-router-dom";
import { saveAs } from 'file-saver';
import moment from "moment-timezone";
import { toast } from "react-toastify";
import Loader from "../../fields/Loader/Loader";

const { TabPane } = Tabs;

const UpdateDelivery = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [activetab, setActiveTab] = useState('1');
    const [searchModal, setSearchModal] = useState(false)
    const [tab1SelectedKeys, setTab1SelectedKeys] = useState([]);
    const [tab1SelectedRows, setTab1SelectedRows] = useState([]);
    const [tab2SelectedKeys, setTab2SelectedKeys] = useState([]);
    const [tab2SelectedRows, setTab2SelectedRows] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [uploadModalVisible, setUploadModalVisible] = useState(false);

    const { weareHouseLoading, getHardDiskListData, updateHardDiskSuccess } = useSelector((state) => state.wearehouse);
    const { data: tableData, count: totalCount, excelData } = getHardDiskListData


    function getData(payload = {}) {
        dispatch(getHardDiskList({ ...payload, activetab })); // directly use variable
    }
    useEffect(() => {
        getData();
    }, [activetab]);

    useEffect(() => {
        if (updateHardDiskSuccess) {
            toast.success("Hard disk status has been updated.");
            getData();
        }
    }, [updateHardDiskSuccess]);


    // Bulk update confirmation
    const handleBulkUpdate = () => {
        if (activetab == 1 ? tab1SelectedKeys.length == 0 : tab2SelectedKeys.length == 0) {
            return toast.error("Please select at least one box to update.");
        }
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to update these boxes?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Update it!"
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = activetab == 1 ? tab1SelectedRows.map((data) => ({
                    // completed_date: data.completed_date,
                    // id: activetab == 1 ? data.id : data.disposition_table_id,
                    spec_id: data.spec_id,
                    job_spec_id: data.job_spec_id,
                    pickup_date: data.pickup_date,
                    ...(activetab == '2' && { barcode: data.barcode })

                })) : tab2SelectedRows.map((data) => ({
                    // completed_date: data.completed_date,
                    id: activetab == 1 ? data.id : data.disposition_table_id,
                    ...(activetab == '2' && { barcode: data.barcode })
                }))
                // Dispatch your bulk update Redux action here
                dispatch(updateHardDiskStatus({ postData: { datas: payload, activetab, type: 'entry' } }))

            }
        });
    };


    // Download Excel Template
    const handleDownloadExcel = () => {
        if (!excelData || excelData.length === 0) {
            toast.error("No data available to download!");
            return;
        }
        // Define headers
        const headers = [
            "Box Number",
            "Pickup Date",
            "Customer",
            "Spec",
            "Hard Drive Delivered"
        ];

        // Map tableData into rows
        const dataRows = excelData.map((row) => [
            row.barcode || row.barcode || "",  // adapt field depending on tab
            row.pickup_date || "",
            row.customer_name || row.box_customer?.customername || "",
            row.spec_id || row.spec || "",
            // row.completed_date || "",
            row.is_hard_disk_delivered == 1 ? "Yes" : "", // export as 1/0
        ]);

        // Combine headers + data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...dataRows]);

        // Create workbook
        const workbook = XLSX.utils.book_new();

        // Append main sheet with actual data
        XLSX.utils.book_append_sheet(workbook, worksheet, "HardDiskStatus");

        // Create Reference sheet
        const referenceSheet = XLSX.utils.aoa_to_sheet([
            ["Value", "Meaning"],
            [Number(1), "Yes"],
            [Number(0), "No"],
        ]);

        XLSX.utils.book_append_sheet(workbook, referenceSheet, "Reference");

        // Export workbook
        XLSX.writeFile(workbook, "HardDisk_Update.xlsx");
    };



    const handleHardDiskUpdate = (record) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Is Hard Disk has been Delivered for this boxes to this Customer",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Deliver it!"
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = [{
                    // completed_date: record.completed_date,
                    pickup_date: record.pickup_date,
                    job_spec_id: record.job_spec_id,
                    spec_id: record.spec_id,
                    // completed_date: moment().format("MM/DD/YYYY"),
                    // id: activetab == '1' ? record.id : record.disposition_table_id,
                    ...(activetab == '2' && { barcode: record.barcode })

                }]
                dispatch(updateHardDiskStatus({ postData: { datas: payload, activetab, type: 'entry' } }))

            }
        });
    };


    const columns = [
        {
            title: "Pickup Date",
            dataIndex: "pickup_date",
            key: "pickup_date",
            render: (_, record) => (
                record.pickup_date == null ? 'N/A' : record.pickup_date
            ),
            // render: (created_at) =>
            //     moment(created_at).tz("America/New_York").format("MM-DD-YYYY hh:mm A"),
            align: "center",
        },
        {
            title: "Customer",
            dataIndex: "customername", // Ensure the correct key
            key: "customername",
            align: "center",
        },
        {
            title: "Spec",
            dataIndex: "spec_id",
            key: "spec_id",
            align: "center",
            // render: (_, record) => `${record.is_completed || 0} / ${record.input_number || 0}`,
        },
        {
            title: "No of Boxes",
            dataIndex: "no_of_boxes",
            key: "no_of_boxes",
            align: "center",
            // render: (_, record) => `${record.is_completed || 0} / ${record.input_number || 0}`,
        },
        // {
        //     title: "Completed Date",
        //     dataIndex: "completed_date",
        //     key: "completed_date",
        //     align: "center",
        //     // render: (_, record) => `${record.is_completed || 0} / ${record.input_number || 0}`,
        // },
        {
            title: 'View Boxes',
            // dataIndex: "view_boxes",
            // key: "view_boxes",
            align: 'center',
            render: data => (
                <Space>
                    <Tooltip title="View Boxes">
                        <Button
                            shape="circle"
                            className="border-20"
                            icon={<ArrowRightOutlined style={{ color: "blue" }} />}
                            onClick={() =>
                                navigate("/view-boxes", {
                                    state: {
                                        spec_id: data.spec_id,
                                        job_spec_id: data.job_spec_id,
                                        pickup_date: data.pickup_date,
                                        type: 'harddisk'
                                    },
                                })
                            }
                        />
                    </Tooltip>
                </Space>
            ),
        },

        // {
        //     title: "Hard Disk Delivered",
        //     key: "action",
        //     align: "center",
        //     render: (record) => (
        //         <Space>
        //             <Tooltip title="Update Status">
        //                 <Checkbox
        //                     checked={record?.is_hard_disk_delivered == 1}
        //                     onChange={() => handleHardDiskUpdate(record)}
        //                 />
        //             </Tooltip>
        //         </Space>
        //     ),
        // }
    ];


    const boxviewColumn = [
        {
            title: "Box Number",
            dataIndex: "barcode",
            key: "barcode",
            align: "center",
        }, {
            title: "Pickup Date",
            dataIndex: "pickup_date",
            key: "pickup_date",
            render: (_, record) => (
                record.pickup_date == null ? 'NA' : record.pickup_date
            ),
            align: "center",
        },
        {
            title: "Customer",
            dataIndex: "customername", // fallback if box_customer is not loaded
            key: "customername",
            render: (_, record) => record.box_customer?.customername || record.customername,
            align: "center",
        },
        {
            title: "Spec",
            dataIndex: "spec_id",
            key: "spec_id",
            align: "center",
        },
        {
            title: "Completed Date",
            dataIndex: "completed_date",
            key: "completed_date",
            align: "center",
        },
        {
            title: "Hard Drive Delivered",
            key: "action",
            align: "center",
            render: (_, record) => (
                <Space>
                    <Tooltip title="Update Status">
                        <Checkbox
                            checked={record?.is_hard_disk_delivered == 1}
                            onChange={() => handleHardDiskUpdate(record)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    const boxviewDataSource = [
        {
            key: '1',
            box_number: '123450001',
            customername: 'Test Customer 1',
            spec: '12345',
            completed_date: '09/15/2023',
            hard_disk_delivered: 'Yes',

        },
        {
            key: '2',
            box_number: '123450002',
            customername: 'Test Customer 2',
            spec: '12345',
            completed_date: '10/15/2023',
            hard_disk_delivered: 'Yes',
        },
        {
            key: '3',
            box_number: '123450002',
            customername: 'Test Customer 3',
            spec: '12345',
            completed_date: '12/15/2023',
            hard_disk_delivered: 'Yes',
        },
    ];

    const rowSelectionTab1 = {
        selectedRowKeys: tab1SelectedKeys,
        onChange: (newSelectedRowKeys, newSelectedRows) => {
            setTab1SelectedKeys(newSelectedRowKeys);
            setTab1SelectedRows(newSelectedRows); // or keep actual rows if needed
        },
    };

    // Row selection for Tab 2
    const rowSelectionTab2 = {
        selectedRowKeys: tab2SelectedKeys,
        onChange: (newSelectedRowKeys, newSelectedRows) => {
            setTab2SelectedKeys(newSelectedRowKeys);
            setTab2SelectedRows(newSelectedRows);
        },
    };
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        setFileList([]);
    };
    const excelDateToJSDate = (serial) => {
        const utc_days = Math.floor(serial - 25569);
        const utc_value = utc_days * 86400; // seconds in a day
        const date_info = new Date(utc_value * 1000); // convert to ms
        return moment(date_info).format("MM/DD/YYYY");
    };

    const handleUpload = async () => {
        const allowedExtensions = ["xlsx", "xls", "xlsm", "xltx", "ods", "xlsb"];
        if (!fileList.length) {
            toast.error("Please select an Excel file to upload!");
            return;
        }

        const file = fileList[0];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Invalid file type! Please upload a valid Excel file.");
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet);

            let hasErrors = false;

            // if (jsonData.length > tableData.length) {
            //     toast.error("You have uploaded more records than allowed!");
            //     hasErrors = true;
            // }

            jsonData.forEach((row, index) => {
                if (!row["Box Number"]) {
                    toast.error(`Row ${index + 1}: Missing required Box Number.`);
                    hasErrors = true;
                }
                if (row["Completed Date"] && typeof row["Completed Date"] == "number") {
                    row["Completed Date"] = excelDateToJSDate(row["Completed Date"]);
                }
            });

            if (!hasErrors) {
                // Filter only rows with Hard Disk Delivered == 1
                const filteredRows = jsonData.filter(
                    (row) => row["Hard Drive Delivered"] == 1
                );

                const payload = filteredRows.map((row) => ({
                    completed_date: row["Completed Date"] || null,
                    id: row["ID"] || null, // should come from Excel export
                    barcode: row["Box Number"]
                }));

                const postData = {
                    datas: payload,
                    activetab: "2",
                    type: 'excel'
                };
                dispatch(updateHardDiskStatus({ postData }));
                setFileList([]);
                setIsModalOpen(false);
                setUploadModalVisible(true);
                // toast.success("Excel file uploaded successfully!");
                // navigate(`/wearhouse`);
            }


        };



        reader.readAsArrayBuffer(file);
    };


    return (
        <div>
            <Loader loading={weareHouseLoading} />
            <PageHeader HeaderText="Update Delivery" Breadcrumb={[{ name: "Update Delivery" }]} backButtonUrl="" />
            <Card style={{ marginTop: "-28px", }}
                title="Update Hard Drive Delivery Status"
                extra={
                    <></>
                }
            >
                <Tabs
                    activeKey={activetab}
                    defaultActiveKey="1"
                    onChange={(key) => setActiveTab(key)}
                    type="card"
                    tabBarExtraContent={
                        <div style={{ display: "flex", gap: "10px" }}>
                            {/* <SearchComponent style={{ width: '250px' }}
                                placeholder="Search by Customer"
                            />
                            <DatePicker
                                style={{ width: '200px' }}
                                placeholder="Select Pickup Date"
                                value={searchDate}
                                onChange={(date) => setSearchDate(date)}
                                format="MM/DD/YYYY"
                            /> */}
                            <Button
                                style={{ gap: '10px' }}
                                className="btn btn-success"
                                icon={<ImCheckboxChecked style={{ marginRight: "8px" }} />}
                                shape="round"
                                // type="primary"
                                onClick={handleBulkUpdate}
                            >
                                Bulk Update Status
                            </Button>
                            <Button
                                style={{ backgroundColor: '#da7e22ff' }}
                                shape="round"
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={handleDownloadExcel}
                            >
                                Download Template
                            </Button>
                            <Button
                                style={{ backgroundColor: '#7e0e0eff' }}
                                shape="round"
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModal}
                            >
                                Upload Excel
                            </Button>
                            {/* <Button
                                className="primary-btn"
                                icon={<SearchOutlined />}
                                shape="round"
                                type="primary"
                                onClick={() => setSearchModal(true)}
                            >
                                Search Filter By Date
                            </Button> */}
                        </div>
                    }
                >
                    <TabPane tab="Pickup Date View" key="1">
                        <TableComponent
                            rowSelection={rowSelectionTab1}
                            columns={columns}
                            dataSource={tableData}
                            rowKey="key"
                            // TotalDataCount={totalCount}
                            size="small"
                            onChangeDispatch={getData}
                        />
                    </TabPane>

                    <TabPane tab="Box View" key="2">
                        <TableComponent
                            rowSelection={rowSelectionTab2}
                            columns={boxviewColumn}
                            dataSource={tableData}
                            // TotalDataCount={totalCount}
                            size="small"
                            onChangeDispatch={getData}
                        />
                    </TabPane>
                </Tabs>

                <Modal title="Upload Excel File" open={isModalOpen} onOk={handleUpload} onCancel={handleCancel} okText="Upload">
                    <Upload
                        beforeUpload={(file) => {
                            setFileList([file]);
                            return false;
                        }}
                        fileList={fileList}
                        accept=".xlsx, .xls"
                    >
                        <Button icon={<UploadOutlined />}>Select Excel File</Button>
                    </Upload>
                </Modal>
            </Card>
            {weareHouseLoading ? <Loader /> : <>
                <Modal
                    title="Upload in Progress"
                    open={uploadModalVisible}
                    footer={[
                        <Button key="logs" type="primary" className='primary-btn' onClick={() => navigate("/upload-log", { state: { activeTab: "hard-disk" } })}>
                            Go to Upload Logs
                        </Button>,
                    ]}
                    onCancel={() => setUploadModalVisible(false)}
                >
                    <p>Data upload is in progress. Please check upload logs.</p>
                </Modal>
            </>}
        </div>
    );
};

export default UpdateDelivery;
